import { headers } from './requestConfig';
import {
  playerShortlist,
  playerShortlistAdd,
  playerShortlistRemove,
} from '../service/links';

export const getShortlist = async () =>
  fetch(playerShortlist, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

export const addToShortlist = async (playerId, note) =>
  fetch(playerShortlistAdd, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(
      note === undefined ? { playerId } : { playerId, note }
    ),
  });

export const removeFromShortlist = async (playerId) =>
  fetch(playerShortlistRemove, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ playerId }),
  });
